const formControls = () => {
    if (document.querySelector('.stoof-acf-form')) {
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const allForms = document.querySelectorAll('.stoof-acf-form');
        allForms.forEach(form => {
            const fileUploadsMultiple = form.querySelectorAll('.stoof-file-upload-allow-multiple');
            if(fileUploadsMultiple.length > 0){
                fileUploadsMultiple.forEach(upload =>{
                    let inputField = upload.querySelector('input[type="file"]');
                    let hiddenField = upload.querySelector('input[type="hidden"]');
                    let inputName = inputField !== null ? inputField.getAttribute('name') : '';
                    if(inputField !== null){
                        inputField.setAttribute('name', inputName+'[]');
                        inputField.setAttribute('multiple', 'multiple');
                    }
                    let hiddenName = hiddenField.getAttribute('name');
                    hiddenField.setAttribute('name', hiddenName+'[]');
                })
            }
        })
        document.addEventListener('click', ev => {
            if (ev.target.classList.contains('stoof-form-advance-button')) {
                ev.preventDefault();
                const form = ev.target.closest('.stoof-acf-form');
                advanceFunction(form, ev.target);

            }
            if (ev.target.classList.contains('stoof-form-back-button')) {
                ev.preventDefault();
                const form = ev.target.closest('.stoof-acf-form');
                let active = form.querySelector('.stoof-form-element.d-block');
                let prev = active.previousElementSibling;
                active.classList.remove('d-block');
                prev.classList.remove('d-none');
                prev.classList.add('d-block');
            }
            if (ev.target.classList.contains('stoof-form-last-button')) {
                ev.preventDefault();
                const form = ev.target.closest('.stoof-acf-form');
                advanceFunction(form, ev.target,'last');
            } else return;
        });

        const validateInputsViaAjax = (form_data, form, page = '', resolve) => {
            const last = page === 'last' ? true : false;

            const active = !last ? form.querySelectorAll('.stoof-form-element.d-block') : form.querySelectorAll('.stoof-form-element');
            let temp = [];
            if (active.length > 0) {

                active.forEach(el => {
                    let arr = Array.from(el.querySelectorAll('input'));
                    let text = Array.from(el.querySelectorAll('textarea'));
                    let select = Array.from(el.querySelectorAll('select'));
                    temp = temp.concat(arr);
                    temp = temp.concat(text);
                    temp = temp.concat(select);
                })
            }

            const allInputs = temp;
            let honey = form.querySelector('input[name="a_password"]');
            let cats = form.getAttribute('data-categories');
            let offer = form.getAttribute('data-job-offer');
            let theForm = new FormData(form);
            theForm.append('action', 'stoof_form');
            theForm.append('honey', honey.value);
            theForm.append('position', page);
            theForm.append('post_id', form_data._acf_post_id);
            theForm.append('the_cats', cats);
            theForm.append('the_job', offer);
            theForm.delete('_acf_nonce');
            theForm.delete('_acf_validation');
            theForm.delete('_acf_post_id');
            theForm.delete('_acf_screen');
            theForm.delete('_acf_form');
            theForm.delete('a_password');
         /*   let data = {
                nonce: form_data.stoof_form_nonce_field,
                action: 'stoof_form',
                post_id: form_data._acf_post_id,
                honey: honey.value,
                position: page,
            };*/
            let pageValues = {};
            if (allInputs.length > 0) {
                allInputs.forEach(inp => {
                    if (inp.name.startsWith('acf[') && !inp.name.endsWith('[]') && inp.type !== 'radio') {
                       pageValues[inp.name.replace('acf[', '').replace(']', '')] = inp.value;

                        if (inp.type === 'hidden') {
                            if(inp.closest('.acf-field-radio') === null || inp.closest('.acf-basic-uploader')){

                                let search = inp.name + '[]';
                                let allSubInputs = form.querySelectorAll(`input[name="${search}"]`);
                                let arr = [];
                                allSubInputs.forEach(inp => {
                                    if (inp.checked === true) {
                                        arr.push(inp.defaultValue)
                                    }
                                })
                                pageValues[inp.name.replace('acf[', '').replace(']', '')] = arr;
                            } else{
                                if(!inp.closest('.acf-basic-uploader')){
                                    const parent = inp.parentElement;
                                    const list = parent.querySelector('.acf-radio-list');
                                    const active = list.querySelector('.stoof-box-active');
                                    const activeInput = active.querySelector(`input[type="radio"]`);

                                    pageValues[inp.name.replace('acf[', '').replace(']', '')] = activeInput.value;
                                }

                            }

                        }
                      /*  if(inp.type === 'file'){
                            pageValues[inp.name.replace('acf[', '').replace(']', '')] = inp.files[0];
                        }*/


                    }else if (inp.name.startsWith('acf[') && inp.name.endsWith('[]')){
                            if(inp.type === 'file'){
                                pageValues[inp.name.replace('acf[', '').replace(']', '').replace('[]', '')] = inp.value;
                            }
                    }

                })
            }
            let jobson = JSON.stringify(pageValues);
            theForm.append('page_data', jobson );
            //let dataArray = Array.from(form_data);

           // let data_query = new URLSearchParams(data).toString();
            let xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {

                    let result = JSON.parse(this.response);
                    resolve(result);
                    // check response and give back validation / go to next page / trigger success message
                }

            }

            xhttp.open("POST", wp_environment.stoof_ajax_url, true);
            //xhttp.setRequestHeader("Content-type", "multipart/form-data");
            xhttp.send(theForm);
        }
        const serialize = (data) => {
            let obj = {};
            for (let [key, value] of data) {
                obj[key] = value;
            }
            return obj;
        }
        const createFormObjectAndSerializeIt = (form) => {
            let data = new FormData(form);
            return serialize(data);
        }

        async function advanceFunction(form, targetButton, last = '') {
            targetButton.classList.add('disabled');
            check_data(form, last).then(result => {
                targetButton.classList.remove('disabled');
                let arr = [];
                let errors = [];
                let all = [];
                let ks = Object.keys(result);
                let hasFalse = false;
                ks.forEach(k => {
                    if (result[k] === false) {
                        hasFalse = true;
                        errors.push(k);
                    }
                    all.push(k);
                    arr[k] = result[k];
                })
                // clear errors on resubmit
                all.forEach(el => {
                    let field = form.querySelector(`div[data-key=${el}]`);
                    if(field !== null){
                        field.classList.remove('stoof-not-valid');
                    }

                })
                // mark errors and give out message
                if (hasFalse) {
                    //alert('Please fill out the required fields.')
                    errors.forEach(err => {
                        let field = form.querySelector(`div[data-key=${err}]`);
                        if(field !== null){
                            field.classList.add('stoof-not-valid');
                        }

                    })

                } else if (last === '') {

                    let active = form.querySelector('.stoof-form-element.d-block');
                    let next = active.nextElementSibling;
                    active.classList.remove('d-block');
                    next.classList.remove('d-none');
                    next.classList.add('d-block');
                    scrollToBlur(form);
                } else {
                    let active = form.querySelector('.stoof-form-element.d-block');
                    active.classList.remove('d-block');
                    const container = document.createElement('div');
                    let headingText = form.getAttribute('data-thank-you-heading');
                    let textText = form.getAttribute('data-thank-you-text');
                    let buttonText = form.getAttribute('data-thank-you-button');
                    container.classList.add('stoof-form-element', 'd-block', 'stoof-thank-you-message');
                    const heading = document.createElement('h3');
                    heading.classList.add('text-uppercase');
                    const okBtn = document.createElement('button');
                    const textContent = document.createElement('p');
                    textContent.innerHTML = textText;
                    okBtn.classList.add('btn', 'btn-primary', 'stoof-ok-button');
                    okBtn.innerHTML=buttonText;
                    heading.innerHTML=headingText;
                    container.appendChild(heading);
                    container.appendChild(textContent)
                    container.appendChild(okBtn);
                    form.appendChild(container);
                    okBtn.addEventListener('click', ev =>{
                        form.reset();
                        container.remove();
                        const firstPage = form.querySelector('.stoof-form-element');
                        firstPage.classList.add('d-block');
                    })
                    scrollToBlur(form);

                }
            })

        }

        const check_data = (form, last = '') => {
            return new Promise(resolve => {
                validateInputsViaAjax(createFormObjectAndSerializeIt(form), form, last, resolve);
            })
        }

        const scrollToBlur = (form) =>{
            if(vw < 1025){
                let blur = form.closest('.stoof-blurred-container')
                if(typeof blur !== 'undefined') blur.scrollIntoView();
            }
        }

    }

}
export default formControls;